import { faUser } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Stack, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { formatDate, formatRelative } from "date-fns";
import { capitalize } from "lodash";

import { BasicPrincipalFragment } from "@/hooks/queries.graphql";
import { principalPictureUrl } from "@/utils/principal";

import { Typography } from "../../ui-v2";

type FileSidebarSectionProps = {
  createdBy?: BasicPrincipalFragment;
  createdAt: Date | string;
};

const Img = styled("img")(() => ({
  height: "1.75rem",
  width: "1.75rem",
  borderRadius: "50%",
}));

export const CreationInfo = (props: FileSidebarSectionProps) => {
  const { createdBy, createdAt } = props;

  const pictureUrl = principalPictureUrl(createdBy);
  const profilePicture = pictureUrl ? (
    <Img src={pictureUrl} draggable="false" />
  ) : (
    <Box
      sx={{
        height: "1.75rem",
        width: "1.75rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <FontAwesomeIcon size="lg" icon={faUser} />
    </Box>
  );

  const author = createdBy?.displayName || "Unknown";

  return (
    <section>
      <Typography fontWeight={400} color="secondary.2">
        Created By
      </Typography>
      <Tooltip
        followCursor
        enterDelay={250}
        enterNextDelay={250}
        title={`Created by ${author} on ${formatDate(createdAt, "PPpp")}`}
        arrow
      >
        <Stack
          direction="row"
          spacing={3}
          sx={{
            alignItems: "center",
            flexGrow: 1,
            paddingX: 1,
            paddingY: 2,
          }}
        >
          <Box
            sx={{
              flexShrink: 0,
            }}
          >
            {profilePicture}
          </Box>
          <Stack
            direction="column"
            sx={{
              flex: 1,
              justifyContent: "center",
              paddingBottom: 1,
              rowGap: 1,
              overflow: "hidden",
              cursor: "default",
            }}
          >
            <Typography
              variant="small"
              lineHeight={1}
              color="secondary.200"
              noWrap
              textOverflow="ellipsis"
            >
              {author}
            </Typography>
            <Typography
              variant="small"
              lineHeight={1}
              fontWeight="light"
              noWrap
              textOverflow="ellipsis"
              color="secondary.300"
            >
              {capitalize(formatRelative(createdAt, new Date()))}
            </Typography>
          </Stack>
        </Stack>
      </Tooltip>
    </section>
  );
};
